var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        "close-on-press-escape": _vm.closeOnPressEscape,
        width: "916px",
        height: "auto",
        top: "10vh",
        title: "",
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c(
          "div",
          {
            staticClass: "flex flex-middle flex-between",
            staticStyle: { height: "36px", width: "100%" },
          },
          [
            _c(
              "span",
              {
                staticClass: "flex flex-middle",
                staticStyle: { height: "36px" },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.videoName))]),
                _vm.videoId
                  ? _c("span", { staticClass: "videoId flex flex-middle" }, [
                      _vm._v("ID: " + _vm._s(_vm.videoId)),
                    ])
                  : _vm._e(),
                _vm.videoInfo &&
                Object.keys(_vm.videoInfo).length > 0 &&
                _vm.videoInfo.isInvalid !== 1
                  ? _c("span", { staticClass: "status flex" }, [
                      _vm.videoInfo.desensitizationRule === 1
                        ? _c(
                            "span",
                            {
                              class:
                                _vm.videoInfo.statusList[
                                  _vm.videoInfo.autoDesensitizedStatus - 1
                                ].class,
                              staticStyle: {
                                "font-size": "12px",
                                "margin-left": "8px",
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  _vm.videoInfo.statusList[
                                    _vm.videoInfo.autoDesensitizedStatus - 1
                                  ].icon,
                                  "mr-1",
                                ],
                              }),
                              _vm._v("无需脱敏"),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              class:
                                _vm.videoInfo.statusList[
                                  _vm.videoInfo.autoDesensitizedStatus - 1
                                ].class,
                              staticStyle: {
                                "font-size": "12px",
                                "margin-left": "8px",
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  _vm.videoInfo.statusList[
                                    _vm.videoInfo.autoDesensitizedStatus - 1
                                  ].icon,
                                  "mr-1",
                                ],
                              }),
                              _vm._v(
                                _vm._s(
                                  _vm.videoInfo.statusList[
                                    _vm.videoInfo.autoDesensitizedStatus - 1
                                  ].name
                                )
                              ),
                            ]
                          ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm.videoInfo && _vm.videoInfo.isMe
              ? _c(
                  "span",
                  {
                    staticClass: "flex flex-middle",
                    staticStyle: { height: "36px" },
                  },
                  [
                    _vm.videoInfo && Object.keys(_vm.videoInfo).length > 0
                      ? _c("span", { staticClass: "status flex flex-middle" }, [
                          _vm.videoInfo.isInvalid !== 1
                            ? _c(
                                "span",
                                [
                                  _vm.videoInfo.desensitizationRule === 0 &&
                                  _vm.videoInfo.isEmptyMirror !== 1 &&
                                  _vm.videoInfo.autoDesensitizedStatus != 1
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: { "font-size": "14px" },
                                          attrs: {
                                            size: "mini",
                                            disabled:
                                              _vm.videoInfo
                                                .autoDesensitizedStatus === 1,
                                          },
                                          on: { click: _vm.handleClickReload },
                                        },
                                        [_vm._v("重新脱敏")]
                                      )
                                    : _vm._e(),
                                  _vm.videoInfo.isEmptyMirror !== 1 &&
                                  _vm.videoInfo.autoDesensitizedStatus === 3
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: { "font-size": "14px" },
                                          attrs: {
                                            size: "mini",
                                            disabled:
                                              _vm.videoInfo
                                                .autoDesensitizedStatus === 1,
                                          },
                                          on: { click: _vm.reForChuli },
                                        },
                                        [_vm._v("重新处理")]
                                      )
                                    : _vm._e(),
                                  _vm.videoInfo.isEmptyMirror !== 1 &&
                                  _vm.videoInfo.autoDesensitizedStatus == 2
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: _vm.toDesensitizationVideo,
                                          },
                                        },
                                        [_vm._v("在线脱敏")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "font-size": "14px" },
                                      attrs: { size: "mini" },
                                      on: { click: _vm.setCancelInvalid },
                                    },
                                    [_vm._v("取消“无效素材”")]
                                  ),
                                ],
                                1
                              ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
      _c("div", { staticClass: "choose_resource" }, [
        _vm.visible ? _c("div", { attrs: { id: "msg" } }) : _vm._e(),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      _c("div", { staticClass: "zimu_ls" }, [
        _c("span", [_vm._v(_vm._s(_vm.nowWzData))]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }